import { getArtichokeDownyMildewApi, getArtichokePowderyMildewApi, getMelonFungalDiseasesApi } from "./fieldDataApi";
import { DOWNY_MODEL, MELCAST_MODEL, POWDERY_MODEL, RISK_RECOVERY_CONCURRENCY } from "../config/diseaseRisk.config";
import { getRiskDates, isIncompleteRiskData, normalizeDiseaseRisk } from "../utils/diseaseRiskUtils";

const loaders = {
  [POWDERY_MODEL]: getArtichokePowderyMildewApi,
  [DOWNY_MODEL]: getArtichokeDownyMildewApi,
  [MELCAST_MODEL]: getMelonFungalDiseasesApi,
};

export const fetchDiseaseRisk = async (request, signal) => {
  const load = loaders[request.model];
  if (!load) throw new Error("Modello non supportato.");
  try {
    return normalizeDiseaseRisk(await load(request, signal), request);
  } catch (error) {
    if (signal?.aborted) throw new DOMException("Richiesta annullata", "AbortError");
    if (request.model === MELCAST_MODEL || !isIncompleteRiskData(error)) throw error;
  }

  // A single incomplete window makes the range endpoint fail. Recover only
  // this data-quality error; authentication/upstream failures stop all workers.
  const dates = getRiskDates(request.from, request.to);
  const results = [];
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener("abort", abort, { once: true });
  if (signal?.aborted) controller.abort();
  let cursor = 0;
  let fatalError;
  const worker = async () => {
    while (!controller.signal.aborted && cursor < dates.length) {
      const date = dates[cursor++];
      const dailyRequest = { ...request, from: date, to: date };
      try {
        const data = normalizeDiseaseRisk(await load(dailyRequest, controller.signal), dailyRequest);
        results.push(...data.assessments);
      } catch (error) {
        if (!isIncompleteRiskData(error)) {
          fatalError = fatalError || error;
          controller.abort();
        }
      }
    }
  };
  try {
    await Promise.all(Array.from({ length: Math.min(RISK_RECOVERY_CONCURRENCY, dates.length) }, worker));
    if (fatalError) throw fatalError;
    if (signal?.aborted) throw new DOMException("Richiesta annullata", "AbortError");
    return normalizeDiseaseRisk(results, request);
  } finally {
    signal?.removeEventListener("abort", abort);
  }
};
